import axios from 'axios';
import { useNavigate } from 'react-router-dom'; 


export const handleProfile = (navigate, closeMenu) => {
    closeMenu?.();
    navigate('/profile');
  };

export const handleChangePassword = (navigate, closeMenu) => {
    closeMenu?.();
    navigate('/settings/change-password');
  };

  export const handleLogout = async (logoutFn, setMobileOpen, navigate) => {
    try {
      setMobileOpen?.(false);
      
      // Call the logout function from AuthContext
      if (logoutFn) {
        await logoutFn();
        // AuthContext will handle the navigation, so we don't need to do anything else
        return;
      }
      
      // Fallback if no logoutFn provided
      console.log('[NavigationHandler] No logoutFn provided, using fallback');
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
      delete axios.defaults.headers.common['Authorization'];
      
      // Use React Router navigation
      if (navigate) {
        navigate('/login', { replace: true });
      } else {
        // Fallback to window.location if navigate is not available
        window.location.href = '/login';
      }
      
    } catch (error) {
      console.error('Logout error:', error);
      // Even on error, clear auth data and redirect
      try {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('user');
        delete axios.defaults.headers.common['Authorization'];
        
        if (navigate) {
          navigate('/login', { replace: true });
        } else {
          window.location.href = '/login';
        }
      } catch (e) {
        console.error('Fallback logout error:', e);
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = '/login';
      }
    }
  };